import React from 'react';
import { Link } from 'react-router-dom';
class SideBar extends React.Component {
    constructor(props) {
        super(props);
        if (!localStorage.getItem('info')) {
            window.location.href = '/login/seller'
        }
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            local_storage: [],
            user: logged_user,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleSubmit(e) {
        e.preventDefault();
        window.localStorage.removeItem('info')
        window.localStorage.removeItem('pro_pic')
        localStorage.clear();
        window.location.href = '/';
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={pro_pic} style={{ width: "60%", height: "150px", objectFit: 'cover' }} />
                </div>
            )
        } else {
            return (
                <div style={{ height: '170px', marginLeft: '-17px', marginRight: '20px' }}>
                    <img className="" alt="" src={x.img_sidebar} style={{ width: "60%", height: "150px", objectFit: 'cover' }} />
                </div>
            )
        }
    }

    profileName() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_name')) {
            var pro_name = JSON.parse(localStorage.getItem('pro_name'))
            console.log(pro_name)
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{pro_name}</span>
                </div>
            )
        } else {
            return (
                <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                    <span className="profile_name">{this.state.user.first_name}</span>
                </div>
            )
        }
    }

    render() {
        var local_storage = JSON.parse(localStorage.getItem('info'))
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="input_name">
                    {this.profilePic()}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {local_storage.first_name} </span>
                    </div>
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails"><Link to={'/seller-edit-profile'} >プロフィール</Link></span>
                    </div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="input_name">

                    {this.profilePic()}
                    {this.profileName()}
                    {/* <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="profile_name"> {local_storage.first_name} </span>
                    </div> */}
                    <div className="top_bottom_paddings" style={{ paddingRight: '45px' }}>
                        <span className="blue_text content_dertails"><Link to={'/seller-edit-profile'} >プロフィール</Link></span>
                    </div>
                    <div className="mt-5 input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }}>
                        出品者メニュー
                </div>
                    <div className="bigger_pad pt-0">
                        <table className="sidebar_table">
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-dashboard'} className="color_alt sidebar_font">ダッシュボード</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-transaction'} className="color_alt sidebar_font" href="/seller-transaction">販売取引</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/request-home'} className="color_alt sidebar_font" href="/request-home">リクエスト提案</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/service-list'} className="color_alt sidebar_font" href="/service-list">出品サービス管理</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/sales'} className="color_alt sidebar_font">売上管理</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/my-points'} className="color_alt sidebar_font" href="/my-points">振込申請</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/followers'} className="color_alt sidebar_font" href="/followers">フォロワー</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="bigger_pad">
                        <Link to={'/product-upload'}>
                            <button className="sell">出品する</button>
                        </Link>
                    </div>
                    <div className="mt-4 input_name content_dertails guide_text" style={{ width: '85%', marginLeft: '10px' }} >
                        購入者メニュー
                            </div>
                    <div className="bigger_pad pt-0">
                        <table className="sidebar_table">
                            <tbody>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-transaction'} className="color_alt remove_underline sidebar_font" href="/seller-buyer-transaction">購入取引</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-request-home'} className="color_alt remove_underline sidebar_font" href="/seller-buyer-request-home">リクエスト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/purchase-list'} className="color_alt remove_underline sidebar_font">購入一覧</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-favorites'} className="color_alt sidebar_font" href="/seller-favorites">お気に入り</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-followers-buyer'} className="color_alt sidebar_font" href="/seller-followers-buyer">フォロー</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div className="bigger_pad">
                        <table style={{ width: "90%", fontSize: "18px", borderCollapse: "separate", borderSpacing: "10px", }}>
                            <tbody>
                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-buyer-direct-message-list'} className="color_alt sidebar_font">メッセージ</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/seller-change-password'} className="color_alt sidebar_font" href="">パスワード変更</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>


                                <tr>
                                    <td className="sidebar_names">
                                        <Link to={'/'} className="color_alt sidebar_font" onClick={this.handleSubmit.bind(this)}>ログアウト</Link>
                                    </td>
                                    <td className="sidebar_arrow">
                                        >
                                </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }
}
export { SideBar }